import React, { CSSProperties } from "react";

export default function IconAction(props: {
	className?: string;
	style?: CSSProperties;
	color?: string;
	size?: number;
}) {
	return (
		<svg
			className={props.className}
			style={props.style}
			xmlns="http://www.w3.org/2000/svg"
			width={props.size ?? 24}
			height={props.size ?? 24}
			viewBox="0 0 24 24"
		>
			<path
				d="M13.0781 2.03027C13.522 2.1425 13.833 2.54211 13.833 3V9.20019H16.9999C17.352 9.20019 17.6779 9.38524 17.8583 9.6875C18.0387 9.98988 18.047 10.365 17.8798 10.6748L12.0468 21.4756C11.8292 21.8783 11.3656 22.0818 10.9218 21.9697C10.4779 21.8575 10.1669 21.4579 10.1669 21V14.7998H6.99995C6.6479 14.7998 6.32201 14.6148 6.14155 14.3125C5.96121 14.0101 5.95288 13.635 6.12007 13.3252L11.9531 2.52441C12.1707 2.12172 12.6343 1.91825 13.0781 2.03027ZM8.67671 12.7998H11.1669C11.719 12.8 12.1668 13.2477 12.1669 13.7998V17.043L15.3232 11.2002H12.833C12.2809 11.2 11.8331 10.7523 11.833 10.2002V6.95605L8.67671 12.7998Z"
				fill={props.color ?? "black"}
			/>
		</svg>
	);
}
